var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-card',_vm._g(_vm._b({on:{"click":_vm.goToFilteredView}},'common-card',_vm.$attrs,false),_vm.$listeners),[_c('img',{attrs:{"src":_vm.iconSrc,"alt":_vm.typeLabel}}),_c('h5',[_vm._v(_vm._s(_vm.typeLabel))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }